/*
 *
 * @providesModule UnifiedLoginEvents
 *
 */
import {trackTelemetryEvent} from 'TrackTelemetryEvent';
import {TelemetryEventName} from 'TelemetryConstants';
import {getCohort} from 'UnifiedLoginCohortUtility';

export const useUnifiedLoginEvents = () => {
  const trackUnifiedLoginPageClicked = (
    cta: string,
    source: string,
    isSmsOptInChecked: boolean
  ) => {
    const payload = {
      cohort: getCohort(),
      source: source,
      cta: cta,
      sms_opt_in_checked: isSmsOptInChecked,
    };
    trackTelemetryEvent({
      event: TelemetryEventName.NFTUE_UNIFIED_LOGIN_CTA_CLICKED,
      includeUserDetails: true,
      payload,
    });
  };

  const trackSignInMobilePageClicked = (
    cta: string,
    source: string,
    isSmsOptInChecked: boolean
  ) => {
    const payload = {
      cohort: getCohort(),
      source: source,
      cta: cta,
      sms_opt_in_checked: isSmsOptInChecked,
    };
    trackTelemetryEvent({
      event: TelemetryEventName.NFTUE_MOBILE_SIGNIN_CTA_CLICKED,
      includeUserDetails: true,
      payload,
    });
  };

  const trackMobileOtpPageClicked = (
    cta: string,
    source: string,
    success?: boolean,
    failureReason?: string
  ) => {
    const payload = {
      cohort: getCohort(),
      source: source,
      cta: cta,
      ...(success !== undefined && {success: success ? 'yes' : 'no'}),
      ...(failureReason !== undefined && {failure_reason: failureReason}),
    };
    trackTelemetryEvent({
      event: TelemetryEventName.NFTUE_OTP_PAGE_CTA_CLICKED,
      includeUserDetails: true,
      payload,
    });
  };

  const trackSignInEmailPageClicked = (cta: string, source: string, success?: boolean) => {
    const payload = {
      cohort: getCohort(),
      source: source,
      cta: cta,
      ...(success !== undefined && {success: success ? 'yes' : 'no'}),
    };
    trackTelemetryEvent({
      event: TelemetryEventName.NFTUE_EMAIL_PAGE_CTA_CLICKED,
      includeUserDetails: true,
      payload,
    });
  };

  const trackTnCModalSeen = (source: string) => {
    const payload = {
      cohort: getCohort(),
      source: source,
    };
    trackTelemetryEvent({
      event: TelemetryEventName.NFTUE_TNCS_POPUP_SEEN,
      includeUserDetails: true,
      payload,
    });
  };

  const trackTnCModalClicked = (cta: string, source: string) => {
    const payload = {
      cohort: getCohort(),
      source: source,
      cta: cta,
    };
    trackTelemetryEvent({
      event: TelemetryEventName.NFTUE_TNCS_POPUP_CLICKED,
      includeUserDetails: true,
      payload,
    });
  };

  return {
    trackUnifiedLoginPageClicked,
    trackSignInMobilePageClicked,
    trackMobileOtpPageClicked,
    trackSignInEmailPageClicked,
    trackTnCModalSeen,
    trackTnCModalClicked,
  };
};
